module.exports = __webpack_public_path__ + "6c0a99c15c383cc69619deb8e767d422.svg";